import React from 'react'
import Slider from 'react-slick'
import userIcon from "../../assets/images/user.png"

const Testimonials = () => {

    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        swipeToSlide: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,

        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slideToScroll: 1,
                    dots: true,
                    infinite: true,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slideToScroll: 2,
                },
            }
        ]
    }

    return (
        <Slider {...settings}>
            <div className="testimonials py-4 px-3">
                <p>"Rhythm Tours & Travels made our Shimla-Manali trip truly memorable. The attention to detail and personalized service were exceptional. Everything from hotels to transportation was perfectly handled!"
                </p>

                <div className="d-flex align-items-center gap-4 mt-3">
                    <img src={userIcon} className="w-25 h-25 rounded-2" alt="" />
                    <div>
                        <h6 className="mb-0 mt-3">Rahul Shah</h6>
                        <p>Customer</p>
                    </div>
                </div>
            </div>
            <div className="testimonials py-4 px-3">
                <p>"Exploring the backwaters of Kerala with Rhythm Tours was absolute bliss. The hospitality and local guidance were top-notch. It was a completely hassle-free and relaxing vacation for our family."
                </p>

                <div className="d-flex align-items-center gap-4 mt-3">
                    <img src={userIcon} className="w-25 h-25 rounded-2" alt="" />
                    <div>
                        <h6 className="mb-0 mt-3">Riya Jain</h6>
                        <p>Customer</p>
                    </div>
                </div>
            </div>
            <div className="testimonials py-4 px-3">
                <p>"I've been booking my annual family trips with Rhythm Tours for years, and they never disappoint. Their expertise in curated travel experiences is truly unmatched. Best travel agency in Ahmedabad!"
                </p>

                <div className="d-flex align-items-center gap-4 mt-3">
                    <img src={userIcon} className="w-25 h-25 rounded-2" alt="" />
                    <div>
                        <h6 className="mb-0 mt-3">Nilesh Patel</h6>
                        <p>Customer</p>
                    </div>
                </div>
            </div>
            <div className="testimonials py-4 px-3">
                <p>"Our international tour to Dubai was seamless thanks to the team. From visa processing to hotel stays and sightseeing, they managed everything with extreme professionalism and care."
                </p>

                <div className="d-flex align-items-center gap-4 mt-3">
                    <img src={userIcon} className="w-25 h-25 rounded-2" alt="" />
                    <div>
                        <h6 className="mb-0 mt-3">Viral Bhatt</h6>
                        <p>Customer</p>
                    </div>
                </div>
            </div>
        </Slider>
    )
}

export default Testimonials